import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import translate from "@insite/client-framework/Translate";
import { ButtonProps } from "@insite/mobius/Button";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import GridContainer, { GridContainerProps } from "@insite/mobius/GridContainer";
import GridItem, { GridItemProps } from "@insite/mobius/GridItem";
import LazyImage, { LazyImageProps } from "@insite/mobius/LazyImage";
import Link, { LinkPresentationProps } from "@insite/mobius/Link";
import { ModalPresentationProps } from "@insite/mobius/Modal";
import Typography, { TypographyProps } from "@insite/mobius/Typography";
import { breakpointMediaQueries } from "@insite/mobius/utilities";
import getColor from "@insite/mobius/utilities/getColor";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import parse from "html-react-parser";
import React from "react";
import { css } from "styled-components";

interface OwnProps {
    product?: any;
    feilds?: any;
}
type Props = OwnProps;
export interface GaiaMYHProductDetailonPopupStyles {
    headingWrapper?: TypographyProps;
    contentWrapper?: InjectableCss;
    DateWrapper?: InjectableCss;
    DateHeading?: TypographyProps;
    DateConclusion?: TypographyProps;
    IngredientsWrapper?: InjectableCss;
    IngredientsTitle?: TypographyProps;
    IngredientsConclusion?: TypographyProps;
    mainWrapper?: InjectableCss;
    accordianMainWrapper?: InjectableCss;
    accordianWrapper?: InjectableCss;
    accordianSectionTitle?: TypographyProps;
    accordianContentWrapper?: InjectableCss;
    conclusionContentWrapper?: InjectableCss;
    purityTestGridContainer?: GridContainerProps;
    purityTestGridItem?: GridItemProps;
    purityTestHeadingWrapper?: GridContainerProps;
    purityTestHeadingWidth?: GridItemProps;
    integrityTestHeadingWidth?: GridItemProps;
    purityTestResultWrapper?: GridContainerProps;
    purityTestResultWidth?: GridItemProps;
    integrityTestResultWidth?: GridItemProps;
    viewButton?: ButtonProps;
    certificateModal?: ModalPresentationProps;
    modalWarpper?: InjectableCss;
    subTitleWrapper?: InjectableCss;
    subtitle?: TypographyProps;
    printResult?: LinkPresentationProps;
    categoryImageItem?: InjectableCss;
    contentItem?: InjectableCss;
    image?: LazyImageProps;
    headingcontentWrapper?: TypographyProps;
    subheadingWrapper?: TypographyProps;
}
const styles: GaiaMYHProductDetailonPopupStyles = {
    headingWrapper: {
        variant: "h2",
        css: css`
            font-size: 22px;
            background: #c4d6a4;
            padding: 18px 20px 14px;
            margin-bottom: 0;
            font-weight: unset;
            color: #183028;
            font-family: LibreBaskervilleBold;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        font-size: 18px;
                        padding: 20px;
                        text-align: center;
                    `,
                    css`
                        font-size: 18px;
                        padding: 20px;
                        text-align: center;
                    `,
                    css``,
                    css``,
                    css``,
                ])};
        `,
    },
    contentWrapper: {
        css: css`
            padding: 28px 20px 24px;
            background: #f3f3f3;
        `,
    },
    DateWrapper: {
        css: css`
            display: flex;
            flex-direction: row;
            column-gap: 150px;
            margin-bottom: 26px;
            > span {
                font-weight: normal;
            }
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        column-gap: 44px;
                    `,
                    css`
                        column-gap: 44px;
                    `,
                    css``,
                    css``,
                    css``,
                ])};
        `,
    },
    DateHeading: {
        css: css`
            font-family: LatoBold;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        font-size: 10px;
                    `,
                    css`
                        font-size: 10px;
                    `,
                    css``,
                    css``,
                    css``,
                ])};
        `,
    },
    DateConclusion: {
        css: css`
            font-family: Lato;
            margin-left: 5px;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        margin-left: 0;
                        display: block;
                    `,
                    css`
                        margin-left: 0;
                        display: block;
                    `,
                    css``,
                    css``,
                    css``,
                ])};
        `,
    },
    IngredientsWrapper: {
        css: css`
            display: flex;
            flex-direction: column;
            &:last-child {
                padding: 11px 0 0;
            }
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        font-size: 10px;
                    `,
                    css`
                        font-size: 10px;
                    `,
                    css``,
                    css``,
                    css``,
                ])};
        `,
    },
    IngredientsTitle: {
        css: css`
            font-family: LatoBold;
        `,
    },
    IngredientsConclusion: {
        css: css`
            padding: 11px 0 23px;
            font-family: Lato;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        padding: 5px 0 17px;
                    `,
                    css`
                        padding: 5px 0 17px;
                    `,
                    css``,
                    css``,
                    css``,
                ])};
        `,
    },
    mainWrapper: {
        css: css`
            background: #f3f3f3;
            margin-bottom: 20px;
        `,
    },
    accordianMainWrapper: {
        css: css`
            margin-bottom: 20px;
        `,
    },
    accordianWrapper: {},
    accordianContentWrapper: {
        css: css`
            background: #f3f3f3;
            padding: 28px 20px 24px;
            // margin-bottom: 20px;
        `,
    },
    conclusionContentWrapper: {
        css: css`
            margin: 16px 0 32px;
            font-family: Lato;
            font-size: 16px;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        font-size: 12px;
                        margin: 14px 0 25px;
                    `,
                    css`
                        font-size: 12px;
                        margin: 14px 0 25px;
                    `,
                    css``,
                    css``,
                    css``,
                ])};
        `,
    },
    accordianSectionTitle: {
        variant: "h2",
        size: 16,
        css: css`
            background: #c4d6a4;
            padding: 15px 20px;
            color: #183028;
            margin-bottom: 0;
            font-weight: unset;
            font-family: "LatoBold";
        `,
    },
    purityTestGridContainer: {},
    purityTestGridItem: {
        width: 12,
        css: css`
            padding: 20px 20px 56px;
            flex-direction: column;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        font-size: 10px;
                        padding: 20px 20px 25px;
                    `,
                    css`
                        font-size: 10px;
                        padding: 20px 20px 25px;
                    `,
                    css``,
                    css``,
                    css``,
                ])};
        `,
    },
    purityTestHeadingWrapper: {
        css: css`
            min-width: 100%;
            margin: 0;
            padding: 9.5px 0 11.5px;
            border-bottom: 1px solid #bebebe;
        `,
    },
    purityTestHeadingWidth: {
        width: 3,
        css: css`
            padding: 0 15px;
            text-transform: capitalize;
            font-family: LatoBold;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        padding: 10px 15px;
                    `,
                    css`
                        padding: 10px 15px;
                    `,
                    css``,
                    css``,
                    css``,
                ])};
        `,
    },
    integrityTestHeadingWidth: {
        width: 4,
        css: css`
            padding: 0 15px;
            text-transform: capitalize;
            font-family: LatoBold;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        padding: 10px 15px;
                    `,
                    css`
                        padding: 10px 15px;
                    `,
                    css``,
                    css``,
                    css``,
                ])};
        `,
    },
    integrityTestResultWidth: {
        width: 4,
    },
    purityTestResultWrapper: {
        css: css`
            min-width: 100%;
            margin: 0;
            padding: 9.5px 0 11.5px;
            border-bottom: 1px solid #e5e5e5;
            &:last-child {
                border-bottom: none;
                padding-bottom: 0;
            }
        `,
    },
    purityTestResultWidth: { width: 3 },
    viewButton: {
        variant: "secondary",
        css: css`
            border-radius: 10px;
            color: ${getColor("common.accent")};
            margin: 27px 0 0 8px;
            padding: 0 10px;
            font-family: Lato;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(
                    theme,
                    [
                        null,
                        css`
                            width: 100%;
                        `,
                        null,
                        null,
                        null,
                    ],
                    "max",
                )};
        `,
    },
    certificateModal: {
        size: 900,
        cssOverrides: {
            modalTitle: css`
                padding: 10px 20px;
            `,
            headlineTypography: css`
                font-size: 22px;
                color: ${getColor("primary")};
                margin-bottom: 0;
            `,
            modalContent: css`
                padding: 20px 20px;
            `,
        },
    },
    subTitleWrapper: {
        css: css`
            display: flex;
            flex-direction: column;
            margin-bottom: 13px;
        `,
    },
    subtitle: {
        css: css`
            margin-bottom: 15px;
        `,
    },
    printResult: {
        css: css`
            font-weight: 600;
            max-width: 136px;
            &:focus {
                outline: none;
            }
        `,
    },
    categoryImageItem: {
        css: css`
            display: flex;
            justify-content: space-around;
            background: #f3f3f3;
            padding: 38px 20px 26px;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(
                    theme,
                    [
                        css`
                            justify-content: space-between;
                        `,
                        css`
                            justify-content: space-between;
                        `,
                        null,
                        null,
                        null,
                    ],
                    "max",
                )};
        `,
    },
    image: {
        css: css`
            img {
                width: auto;
            }
            margin-bottom: 22px;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(
                    theme,
                    [
                        css`
                     width: auto !important;
                    }
                       
                    `,
                        css`
                    width: auto !important;
                    }
                    `,
                        null,
                        null,
                        null,
                    ],
                    "max",
                )};
        `,
    },
    contentItem: {
        css: css`
            display: inline-grid;
            text-align: center;
            margin-bottom: 20px;
        `,
    },
    headingcontentWrapper: {
        css: css`
            font-family: LatoBold;
            font-size: 16px;
        `,
    },
    subheadingWrapper: {
        css: css`
            font-family: Lato;
            font-size: 14px;
        `,
    },
};

const GaiaMYHProductDetailonPopup: React.FC<Props> = ({ product, feilds }) => {
    const productTitle = product?.sellable_item["0"].name;
    const masterId = product?.cofc.master_id;
    const manufacturedDate = product?.manufactured_date;
    const bestBy = product?.cofc.best_by;
    const ingredients = product?.cofc.ingredients;
    const concentrationEquivalency = product?.sellable_item["0"].concentration_equivalency;
    const solvent = product?.sellable_item["0"].ingredients_solvent;
    const purityTest = Object.keys(product?.cofc?.purity_tests);
    const integrityTest = Object.keys(product?.cofc?.integrity_tests);

    const printPageHandler = () => {
        window.print();
    };
    return (
        <>
            <StyledWrapper {...styles.subTitleWrapper}>
                <Typography {...styles.subtitle}>
                    Gaia Herbs creates this certificate for all of our products to give customers the proof that each
                    one has been tested and validated for purity, integrity and potency.
                </Typography>
                <Link {...styles.printResult} onClick={printPageHandler}>
                    Print Your Results
                </Link>
            </StyledWrapper>
            <StyledWrapper {...styles.mainWrapper}>
                <Typography {...styles.headingWrapper}>{productTitle}</Typography>
                <StyledWrapper {...styles.contentWrapper}>
                    <StyledWrapper {...styles.DateWrapper}>
                        <Typography {...styles.DateHeading}>
                            {translate("Master ID:")}
                            <Typography {...styles.DateConclusion}>{masterId}</Typography>
                        </Typography>
                        <Typography {...styles.DateHeading}>
                            {translate("MFG Date:")}
                            <Typography {...styles.DateConclusion}>{manufacturedDate}</Typography>
                        </Typography>
                        <Typography {...styles.DateHeading}>
                            {translate("Best By:")}
                            <Typography {...styles.DateConclusion}>{bestBy}</Typography>
                        </Typography>
                    </StyledWrapper>
                    <StyledWrapper {...styles.IngredientsWrapper}>
                        <Typography {...styles.IngredientsTitle}>{translate("Ingredients:")}</Typography>
                        <Typography {...styles.IngredientsConclusion}>{parse(`${ingredients}`)}</Typography>
                    </StyledWrapper>
                    <StyledWrapper {...styles.IngredientsWrapper}>
                        <Typography {...styles.IngredientsTitle}>{translate("Solvents:")}</Typography>
                        <Typography {...styles.IngredientsConclusion}>{solvent}</Typography>
                    </StyledWrapper>
                    <StyledWrapper {...styles.IngredientsWrapper}>
                        <Typography {...styles.IngredientsTitle}>{translate("Concentration equivalency:")}</Typography>
                        <Typography {...styles.IngredientsConclusion}>{concentrationEquivalency}</Typography>
                    </StyledWrapper>
                </StyledWrapper>
            </StyledWrapper>

            <StyledWrapper {...styles.accordianMainWrapper}>
                <StyledWrapper {...styles.accordianWrapper}>
                    <Typography {...styles.accordianSectionTitle}>Purity - Keep It Clean</Typography>
                    <StyledWrapper {...styles.accordianContentWrapper}>
                        <StyledWrapper {...styles.conclusionContentWrapper}>
                            The plants used in our herbal extracts must meet or exceed our standards for purity. Beyond
                            visual and tactile inspection, tests are conducted to ensure the absence of heavy metals,
                            pesticides and other chemical contaminants.
                        </StyledWrapper>
                        {purityTest.map(label => (
                            // eslint-disable-next-line react/jsx-key
                            <GridContainer {...styles.purityTestGridContainer}>
                                <GridItem {...styles.purityTestGridItem}>
                                    <GridContainer {...styles.purityTestHeadingWrapper}>
                                        <GridItem {...styles.purityTestHeadingWidth}>{label}</GridItem>
                                        <GridItem {...styles.purityTestHeadingWidth}>{translate("Method")}</GridItem>
                                        <GridItem {...styles.purityTestHeadingWidth}>
                                            {translate("Specification")}
                                        </GridItem>
                                        <GridItem {...styles.purityTestHeadingWidth}>{translate("Result")}</GridItem>
                                    </GridContainer>

                                    {product?.cofc?.purity_tests[label]?.map((resultData: any) => (
                                        <GridContainer {...styles.purityTestResultWrapper}>
                                            <GridItem {...styles.purityTestResultWidth}>{resultData.name}</GridItem>
                                            <GridItem {...styles.purityTestResultWidth}>{resultData.method}</GridItem>
                                            <GridItem {...styles.purityTestResultWidth}>
                                                {resultData.specification}
                                            </GridItem>
                                            <GridItem {...styles.purityTestResultWidth}>{resultData.result}</GridItem>
                                        </GridContainer>
                                    ))}
                                </GridItem>
                            </GridContainer>
                        ))}
                    </StyledWrapper>
                </StyledWrapper>
            </StyledWrapper>

            <StyledWrapper {...styles.accordianMainWrapper}>
                <StyledWrapper>
                    <StyledWrapper {...styles.accordianWrapper}>
                        <Typography {...styles.accordianSectionTitle}>Integrity - Keep It Real</Typography>

                        <StyledWrapper {...styles.accordianContentWrapper}>
                            <StyledWrapper {...styles.conclusionContentWrapper}>
                                Responsible sourcing practices, correct extraction technology and ideal concentration
                                methods are used to validate the full expression of every ingredient.
                            </StyledWrapper>
                            {integrityTest.map(label => (
                                // eslint-disable-next-line react/jsx-key
                                <GridContainer {...styles.purityTestGridContainer}>
                                    <GridItem {...styles.purityTestGridItem}>
                                        <GridContainer {...styles.purityTestHeadingWrapper}>
                                            <GridItem {...styles.integrityTestHeadingWidth}>{label}</GridItem>
                                            <GridItem {...styles.integrityTestHeadingWidth}>
                                                {translate("Specification")}
                                            </GridItem>
                                            <GridItem {...styles.integrityTestHeadingWidth}>
                                                {translate("Result")}
                                            </GridItem>
                                        </GridContainer>

                                        {product?.cofc?.integrity_tests[label]?.map((resultData: any) => (
                                            <GridContainer {...styles.purityTestResultWrapper}>
                                                <GridItem {...styles.integrityTestResultWidth}>
                                                    {resultData.identity}
                                                </GridItem>
                                                <GridItem {...styles.integrityTestResultWidth}>
                                                    {resultData.specification}
                                                </GridItem>
                                                <GridItem {...styles.integrityTestResultWidth}>
                                                    {resultData.result}
                                                </GridItem>
                                            </GridContainer>
                                        ))}
                                    </GridItem>
                                </GridContainer>
                            ))}
                            <GridContainer {...styles.purityTestGridContainer}>
                                <GridItem {...styles.purityTestGridItem}>
                                    <GridContainer {...styles.purityTestHeadingWrapper}>
                                        <GridItem {...styles.purityTestHeadingWidth}>{translate("Name")}</GridItem>
                                        <GridItem {...styles.purityTestHeadingWidth}>{translate("Method")}</GridItem>
                                        <GridItem {...styles.purityTestHeadingWidth}>
                                            {translate("Specification")}
                                        </GridItem>
                                        <GridItem {...styles.purityTestHeadingWidth}>{translate("Result")}</GridItem>
                                    </GridContainer>

                                    {product?.cofc?.product_integrity_tests?.map((resultData: any) => (
                                        <GridContainer {...styles.purityTestResultWrapper}>
                                            <GridItem {...styles.purityTestResultWidth}>{resultData.name}</GridItem>
                                            <GridItem {...styles.purityTestResultWidth}>{resultData.method}</GridItem>
                                            <GridItem {...styles.purityTestResultWidth}>
                                                {resultData.specification}
                                            </GridItem>
                                            <GridItem {...styles.purityTestResultWidth}>{resultData.result}</GridItem>
                                        </GridContainer>
                                    ))}
                                </GridItem>
                            </GridContainer>
                        </StyledWrapper>
                    </StyledWrapper>
                </StyledWrapper>
            </StyledWrapper>

            <StyledWrapper {...styles.accordianMainWrapper}>
                <StyledWrapper>
                    <StyledWrapper {...styles.accordianWrapper}>
                        <Typography {...styles.accordianSectionTitle}>Potency - Keep It Strong</Typography>
                        <StyledWrapper {...styles.accordianContentWrapper}>
                            <StyledWrapper {...styles.conclusionContentWrapper}>
                                Our methods and procedures for strength properties ensure that the powerful effects of
                                each herb will be utilized.
                            </StyledWrapper>

                            <GridContainer {...styles.purityTestGridContainer}>
                                <GridItem {...styles.purityTestGridItem}>
                                    <GridContainer {...styles.purityTestHeadingWrapper}>
                                        <GridItem {...styles.purityTestHeadingWidth}>
                                            {translate("BioActivity")}
                                        </GridItem>
                                        <GridItem {...styles.purityTestHeadingWidth}>{translate("Method")}</GridItem>
                                        <GridItem {...styles.purityTestHeadingWidth}>
                                            {translate("Specification")}
                                        </GridItem>
                                        <GridItem {...styles.purityTestHeadingWidth}>{translate("Result")}</GridItem>
                                    </GridContainer>

                                    {product?.cofc?.potency_tests?.map((resultData: any) => (
                                        <GridContainer {...styles.purityTestResultWrapper}>
                                            <GridItem {...styles.purityTestResultWidth}>
                                                {resultData.bioactivity}
                                            </GridItem>
                                            <GridItem {...styles.purityTestResultWidth}>{resultData.method}</GridItem>
                                            <GridItem {...styles.purityTestResultWidth}>
                                                {resultData.specification}
                                            </GridItem>
                                            <GridItem {...styles.purityTestResultWidth}>{resultData.result}</GridItem>
                                        </GridContainer>
                                    ))}
                                </GridItem>
                            </GridContainer>
                        </StyledWrapper>
                    </StyledWrapper>
                </StyledWrapper>
            </StyledWrapper>

            <StyledWrapper {...styles.accordianMainWrapper}>
                <StyledWrapper>
                    <StyledWrapper {...styles.accordianWrapper}>
                        <Typography {...styles.accordianSectionTitle}>Quality Assurance Approvals</Typography>
                        <StyledWrapper {...styles.categoryImageItem}>
                            <StyledWrapper {...styles.contentItem}>
                                <LazyImage src={feilds.qAimage1Url} altText={feilds.qAaltText1} {...styles.image} />
                                <Typography as="p" {...styles.headingcontentWrapper}>
                                    Full Name
                                </Typography>
                                <Typography as="p" {...styles.subheadingWrapper}>
                                    Director of Quality
                                </Typography>
                            </StyledWrapper>

                            <StyledWrapper {...styles.contentItem}>
                                <LazyImage src={feilds.qAimage2Url} altText={feilds.qAaltText2} {...styles.image} />
                                <Typography as="p" {...styles.headingcontentWrapper}>
                                    Full Name
                                </Typography>
                                <Typography as="p" {...styles.subheadingWrapper}>
                                    Data Reviewer
                                </Typography>
                            </StyledWrapper>
                        </StyledWrapper>
                    </StyledWrapper>
                </StyledWrapper>
            </StyledWrapper>
        </>
    );
};
export default GaiaMYHProductDetailonPopup;
